(function (scrollLock, Flickity, Sqrl, themeCurrency, Ajaxinate, AOS) {
  class ProductAlternates extends HTMLElement {
    constructor() {
      super();
      this.url = this.getAttribute("product-url");
      this.productId = this.getAttribute("product-id");
    }

    async connectedCallback() {
      const res = await fetch(this.url);
      const html = await res.json();

      // Initialize the DOM parser
      const parser = new DOMParser()
  
      // Parse the text
      const doc = parser.parseFromString(html["product-alternates"], "text/html")
      if (doc && doc.querySelector('.alternative-options')) {
        this.insertAdjacentElement('beforeend', doc.querySelector('.alternative-options'));
      }
        
      //   this.innerHTML = html["product-alternates"].replace(
      //   "shopify-section-product-alternates",
      //   `product-alternates-${this.productId}`
      // );
      const $slider = this.closest("[data-slider]");

      if ($slider) {
        const flkty = Flickity.data($slider);

        flkty && flkty.resize();
      }
    }
  }

  customElements.define("product-alternates", ProductAlternates);
})(
  themeVendor.ScrollLock,
  themeVendor.Flickity,
  themeVendor.Sqrl,
  themeVendor.themeCurrency,
  themeVendor.ajaxinate,
  themeVendor.AOS
);
